/**
 * @generated SignedSource<<17dc177f25962e04ba309d827df57df8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_JWMBoardRoot_queryFragment">;
  readonly " $fragmentType": "src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment";
};
export type src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment$key = {
  readonly " $data"?: src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_workManagementBoard_JWMBoardRoot_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "168d646e3bd99cdb74e5dd694c66c4e0";

export default node;
